import { RemoteGetPaginatedOrganizationTcesSentToIntegrative } from 'data/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetPaginatedOrganizationTcesSentToIntegrative =
  (): RemoteGetPaginatedOrganizationTcesSentToIntegrative => {
    return new RemoteGetPaginatedOrganizationTcesSentToIntegrative(
      makeApiUrlEntities(),
      makeAxiosHttpClient(),
    );
  };
